<template>
  <span :title="title" class="title">
    {{ document.subcorpus.toUpperCase() }} / {{ document.language.substring(0, 2) }} / {{ document.year }}
  </span>
</template>
<script>
  import map from 'lodash/map'
  import reduce from 'lodash/reduce'

  export default {
    props: ['document', 'text', 'elements', 'matches'],
    data() {
      return {
        documentFields: ['subcorpus', 'language', 'text_genre', 'text_subgenre', 'year', 'specialization', 'code']
      }
    },
    computed: {
      title() {
        const fields = reduce(this.documentFields, (result, field) => {
          result[this.$t(`result.context.header.document.${field}`)] = this.$tOr(`filters.ncs_documents.${field}.options`, this.document[field])
          return result
        }, {})
        return map(fields, (v, k) => `${k}: ${v || ''}`).join('\n')
      }
    }
  }
</script>
